// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    RESTOneDrive,
} from './';

/**
 * @export
 * @interface RESTCopyToDocument
 */
export interface RESTCopyToDocument {
    /**
     * @type {RESTOneDrive}
     * @memberof RESTCopyToDocument
     */
    onedrive?: RESTOneDrive;
    /**
     * Specifies the target folder for the copied OneDrive document.
     * @type {string}
     * @memberof RESTCopyToDocument
     */
    folder?: string;
    /**
     * Specifies what version of the OneDrive documents will be copied.
     * @type {string}
     * @memberof RESTCopyToDocument
     */
    documentVersion?: RESTCopyToDocumentDocumentVersionEnum;
    /**
     * Specifies the action that will be performed with the last version of the copied OneDrive document on the destination server.
     * @type {string}
     * @memberof RESTCopyToDocument
     */
    documentLastVersionAction?: RESTCopyToDocumentDocumentLastVersionActionEnum;
    /**
     * Specifies the authentication code. For more information on how to get a device code, see [Get Device Code](#tag/RestoreSession/operation/RestoreSession_DeviceCodeAction). This property is required if you want to use a device code for data restore. 
     * @type {string}
     * @memberof RESTCopyToDocument
     */
    userCode?: string;
    /**
     * Specifies the ID of the Microsoft Entra application that you want to use for restore.
     * @type {string}
     * @memberof RESTCopyToDocument
     */
    applicationId?: string | null;
    /**
     * Specifies a password.
     * @type {string}
     * @memberof RESTCopyToDocument
     */
    applicationCertificatePassword?: string;
    /**
     * Specifies the SSL certificate configured for the Microsoft Entra application that you want to use for data restore. You must provide the certificate as a Base64 string.
     * @type {string}
     * @memberof RESTCopyToDocument
     */
    applicationCertificate?: string;
    /**
     * Specifies the user name that you want to use for authenticating to the organization.
     * @type {string}
     * @memberof RESTCopyToDocument
     */
    userName?: string;
    /**
     * Specifies a password.
     * @type {string}
     * @memberof RESTCopyToDocument
     */
    userPassword?: string;
    /**
     * Specifies the region of the target Microsoft 365 organization.
     * @type {string}
     * @memberof RESTCopyToDocument
     */
    officeRegion?: RESTCopyToDocumentOfficeRegionEnum;
    /**
     * Specifies the name of the target Microsoft 365 organization.
     * @type {string}
     * @memberof RESTCopyToDocument
     */
    organizationName?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum RESTCopyToDocumentDocumentVersionEnum {
    All = 'All',
    Last = 'Last'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTCopyToDocumentDocumentLastVersionActionEnum {
    Overwrite = 'Overwrite',
    Merge = 'Merge'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTCopyToDocumentOfficeRegionEnum {
    Worldwide = 'Worldwide',
    Germany = 'Germany',
    China = 'China',
    UsDefence = 'USDefence',
    UsGovernment = 'USGovernment'
}

